// src/utils/passwordValidation.js - Password rules shared by account activation and password reset

/**
 * Validate password requirements: 8+ characters, uppercase, lowercase, and special character
 * @returns {string} error message, or '' if valid
 */
export const validatePassword = (password) => {
  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }
  if (!/[!@#$%^&*(),.?":{}|<>-]/.test(password)) {
    return 'Password must contain at least one special character (!@#$%^&*...)';
  }
  return '';
};
